import { css } from "@emotion/css"

import Image from "@p-ban/common/src/components/html/Image"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import Text from "../ui/Text/Text"
import MyPageTheme from "./MyPageTheme"
import Divider from "./layout/Divider"

type Props = {
  description?: React.ReactNode
  children: React.ReactNode
} & Pick<React.ComponentProps<typeof Image>, "src" | "alt">

const MyPageMainContent = ({ description, children, src, alt }: Props) => {
  return (
    <MyPageTheme>
      <h2 className={styles.h2}>
        <Image src={src} alt={alt} width={370} height={73} />
      </h2>
      <div className={styles.description}>
        <Text>{description}</Text>
      </div>
      <Spacer size={20} />
      <Divider />
      {children}
    </MyPageTheme>
  )
}

export default MyPageMainContent

const styles = {
  h2: css`
    height: 73px;
  `,
  description: css`
    height: 40px;
  `,
}
